import { BASE_URL } from "@/src/common/config"
import { EntityType } from "@/src/common/types"
import { pages } from "@/src/sb/constants/copy"

export const appendSlash = (r: string) =>
  !r ? "" : r.endsWith("/") ? r : r + "/"

export class URLFactory {
  static commonPages = pages // TODO: refactor to use same factory
  static getUrl(el: keyof typeof URLFactory, ...args: any[]) {
    return typeof URLFactory[el] === "function"
      ? (URLFactory[el] as any)(...args)
      : URLFactory[el]
  }
  static absolute(el: keyof typeof URLFactory, ...args: any[]) {
    return BASE_URL + URLFactory.getUrl(el, ...args)
  }

  static report(slug: string, isFree = false) {
    return appendSlash(`${!isFree ? "/premium" : ""}/article/${slug}`)
  }

  static topicPage(slug: string) {
    return appendSlash(`/topics/${slug}`)
  }

  static dataPageRoot() {
    return appendSlash(`/data`)
  }

  static dataPage(slug: string) {
    return appendSlash(`${URLFactory.dataPageRoot()}${slug}`)
  }

  static country(slug: string) {
    return appendSlash(`${URLFactory.dataPageRoot()}countries/${slug}`)
  }

  static writer(slug: string) {
    return appendSlash(`/writer/${slug}`)
  }
}

export const getNavigationPath = (data: {
  type: string
  slug: string
  bucketSlug?: string
  groupSlug?: string
  tabSlug?: string
  countryRiskSlug?: string
  companySlug?: string
  txnSerialNo?: string
  enableTransactionsProfile?: boolean
  enableLimitedPartnerProfile?: boolean
}): string => {
  const {
    type,
    slug,
    bucketSlug,
    groupSlug,
    tabSlug,
    countryRiskSlug,
    companySlug,
    txnSerialNo,
    enableTransactionsProfile,
    enableLimitedPartnerProfile
  } = data

  const destinationSearchParams = new URLSearchParams()
  if (tabSlug) destinationSearchParams.set("tab", tabSlug)
  if (countryRiskSlug) destinationSearchParams.set("dataset", slug)

  let path = ""

  switch (type) {
    case EntityType.REPORT:
    case EntityType.REPORTS:
      path = `/article/${slug}`
      break
    case EntityType.DATASET:
    case EntityType.DATASETS:
      if (bucketSlug === "datasets") {
        path = `/${bucketSlug}/${slug}/`
      } else if (groupSlug) {
        path = countryRiskSlug
          ? `/${bucketSlug}/${groupSlug}/${countryRiskSlug}/`
          : bucketSlug
          ? `/${bucketSlug}/${groupSlug}/${slug}/`
          : `/data/${groupSlug}/${slug}/`
      }
      break

    case EntityType.COUNTRY_PROFILE:
      path = `/data/countries/${slug}/`
      break

    case EntityType.TRANSACTIONS:
    case EntityType.TRANSACTION:
      if (companySlug) {
        path = `/transactions/?type=recent_transactions&company.slug[]=${encodeURIComponent(
          companySlug
        )}`
      }
      if (txnSerialNo && enableTransactionsProfile) {
        path = `/transactions/${txnSerialNo}/`
      }
      break
    case EntityType.COMPANY:
    case EntityType.COMPANIES:
      path = `/companies/${slug}/`
      break

    case EntityType.LIMITED_PARTNER:
      path = enableLimitedPartnerProfile
        ? `/companies/${slug}`
        : `/transactions/?type=limited_partners&slug[]=${encodeURIComponent(
            slug
          )}`
      break

    default:
      break
  }

  const query = destinationSearchParams.toString()
  return query ? `${path}?${query}` : path
}
